﻿<script lang="ts" setup>
    import addedformfields from './AddedFormFields.vue';
    import availableformfields from './AvailableFormFields.vue';
    import { FormFieldsReference } from './FormEditor.access';
    import BSDropdownButton from '@shared/components/BSDropdownButton.vue';

    const props = defineProps<{
        formFields: FormFieldsReference;
    }>();
</script>

<template>
    <addedformfields :formFields="props.formFields"></addedformfields>

    <div class="form-group">
        <BSDropdownButton menuClass="dd-menu-w-300 dd-menu-h-300">
            <template #toggle>
                <span class="glyphicon glyphicon-plus m-xs-r" aria-hidden="true"></span>
                {{ $Resources.FormEditorAddFieldsBtn }}
            </template>
            <template #content>
                <availableformfields :formFields="props.formFields"></availableformfields>
            </template>
        </BSDropdownButton>
    </div>
</template>

<style></style>

<style scoped></style>
